import { TableColumnsSetting } from '@/interfaces/table-setting';
import { VwbankCommissionModel } from '@/models/imports/vwbank-commission-model';

export class VwbankCommissionSettingsTable {
  public static getColumnsSetting(): TableColumnsSetting<keyof VwbankCommissionModel> {
    return [
      {
        name: 'id',
        text: 'Id',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'importId',
        text: 'Import Id',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'client',
        text: 'Cliente',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'practiceNumber',
        text: 'Num. pratica',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'createdAt',
        type: 'datetime',
        text: 'creato il',
        filter: {
          type: 'dateRange',
        },
      },
      {
        name: 'updatedAt',
        type: 'datetime',
        text: 'modificato il',
        filter: {
          type: 'dateRange',
        },
      },
    ];
  }
}
